import styled from "styled-components";

export const CardContainer = styled.div<{ background; changeSize }>`
    width: 9rem;
    height: 9rem;
    border-radius: 20px;
    background: url(${(props) => props.background});

    ${(props) =>
        props.changeSize
            ? `@media screen and (max-width: 770px) {
                width: 8rem;
                height: 8rem;
            }

            @media screen and (max-width: 480px) {
                width: 6.5rem;
                height: 6.5rem;
            }
            @media screen and (max-width: 360px) {
                width: 5rem;
                height: 5rem;
            }`
            : ""}
`;
export const ContentCard = styled.div<{ background; changeSize }>`
    width: 9rem;
    height: 9rem;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border-radius: 20px;
    background-color: ${(props) => (props.background ? "rgba(0, 0, 0, 0.3)" : "")};

    img {
        width: ${({ changeSize }) => (changeSize ? "80%" : "4.65rem")};
        height: ${({ changeSize }) => (changeSize ? "auto" : "4.65rem")};
        text-shadow: 0 0 2px black;
    }

    ${(props) =>
        props.changeSize
            ? `@media screen and (max-width: 770px) {
                width: 8rem;
                height: 8rem;
            }

            @media screen and (max-width: 480px) {
                margin-left:0.5rem;
                width: 6.5rem;
                height: 6.5rem;

                img {
                    width: 100%;
                    height: auto;
                }
            }
            @media screen and (max-width: 360px) {
                margin-left:1rem;
                width: 5rem;
                height: 5rem;

            }`
            : ""}
`;
